import { useTutorial } from '../../contexts/TutorialContext';
import { useEffect } from 'react';

export default function TutorialWizard() {
  const { isActive, currentStep, steps, nextStep, prevStep, skipTutorial, completeTutorial } = useTutorial();

  useEffect(() => {
    if (!isActive || !steps[currentStep]) return;

    const targetElement = document.querySelector(steps[currentStep].target);
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
      targetElement.classList.add('tutorial-highlight');

      return () => {
        targetElement.classList.remove('tutorial-highlight');
      };
    }
  }, [isActive, currentStep, steps]);

  if (!isActive || !steps[currentStep]) return null;

  const step = steps[currentStep];

  return (
    <>
      {/* Backdrop */}
      <div className="fixed inset-0 bg-black/50 z-50" onClick={skipTutorial}></div>

      {/* Tutorial Box - Prevent click events from reaching backdrop */}
      <div
        onClick={(e) => e.stopPropagation()}
        data-testid="tutorial-wizard"
        className="fixed z-50 bg-white rounded-lg shadow-2xl p-6 max-w-sm border-4 border-blue-500 animate-fade-in-up"
        style={{
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)'
        }}
      >
        {/* Close Button */}
        <button
          onClick={skipTutorial}
          className="absolute top-2 right-2 text-gray-400 hover:text-gray-600 text-2xl leading-none"
        >
          ✕
        </button>

        {/* Step Indicator */}
        <div className="flex items-center gap-2 mb-4">
          {steps.map((_, idx) => (
            <div
              key={idx}
              className={`h-2 flex-1 rounded-full ${
                idx === currentStep ? 'bg-blue-500' : idx < currentStep ? 'bg-blue-300' : 'bg-gray-200'
              }`}
            ></div>
          ))}
          <span className="text-xs text-gray-500 ml-2">
            {currentStep + 1} / {steps.length}
          </span>
        </div>

        {/* Title */}
        <h3 className="text-xl font-bold text-gray-900 mb-3">
          {step.title}
        </h3>

        {/* Content */}
        <p className="text-gray-600 mb-6">
          {step.content}
        </p>

        {/* Navigation */}
        <div className="flex items-center justify-between gap-3">
          <button
            onClick={prevStep}
            disabled={currentStep === 0}
            className="px-4 py-2 text-gray-600 hover:text-gray-800 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            ← Back
          </button>

          <div className="flex gap-2">
            <button
              onClick={skipTutorial}
              className="px-4 py-2 text-gray-500 hover:text-gray-700"
            >
              Skip
            </button>
            <button
              onClick={currentStep === steps.length - 1 ? completeTutorial : nextStep}
              className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
            >
              {currentStep === steps.length - 1 ? 'Selesai' : 'Next →'}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
